module.exports = __webpack_public_path__ + "static/media/29.0f278aa0.svg";